import {
  jb_text_teaser_css_default
} from "./chunk.RJTTUYOX.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-text-teaser/jb-text-teaser.ts
var JbTextTeaser = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this._hovering = false;
  }
  _hoverLinkIn() {
    this._hovering = true;
  }
  _hoverLinkOut() {
    this._hovering = false;
  }
  _trackClick(event) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(event, {
      component_name: "text-teaser",
      interaction_text: this.buttonLabel
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <a
        @jb-link:clicked=${this._trackClick}
        @mouseout=${this._hoverLinkOut}
        @mouseover=${this._hoverLinkIn}
        @blur=${this._hoverLinkOut}
        @focus=${this._hoverLinkIn}
        data-linkable
        ><div
          class=${Rt({
      gray: !!this.hasGrayBackground
    })}
        >
          <h3>${this.headline}</h3>
          <p>${this.text}</p>
          <jb-button-tertiary
            tabindex="-1"
            .forceHover=${this._hovering}
            >${this.buttonLabel}</jb-button-tertiary
          >
        </div></a
      >
    `;
  }
};
JbTextTeaser.styles = jb_text_teaser_css_default;
__decorateClass([
  n()
], JbTextTeaser.prototype, "buttonLabel", 2);
__decorateClass([
  n({ type: Boolean })
], JbTextTeaser.prototype, "hasGrayBackground", 2);
__decorateClass([
  n()
], JbTextTeaser.prototype, "headline", 2);
__decorateClass([
  n()
], JbTextTeaser.prototype, "text", 2);
__decorateClass([
  r2()
], JbTextTeaser.prototype, "_hovering", 2);
JbTextTeaser = __decorateClass([
  customElement("jb-text-teaser")
], JbTextTeaser);

export {
  JbTextTeaser
};
